import React from 'react';
import Portal from './portal';
import PropTypes from 'prop-types';
import $ from 'jquery';
import {observer} from 'mobx-react';
import {observable, autorun, makeObservable} from 'mobx';

@observer
export default class Modal extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    primaryAction: PropTypes.func.isRequired,
    primaryButtonClass: PropTypes.string,
    primaryButtonLabel: PropTypes.string,
    secondaryAction: PropTypes.func,
    secondaryButtonClass: PropTypes.string,
    secondaryButtonLabel: PropTypes.string,
    restoreFocusTo: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
  }

  static defaultProps = {
    primaryButtonLabel: 'Save',
    primaryButtonClass: '',
    secondaryButtonLabel: 'Exit',
    secondaryButtonClass: '',
    children: ''
  }

  @observable show = false;

  constructor(props) {
    super(props);
    makeObservable(this);
    autorun(() => {
      // show or hide the modal using bootstrap methods
      if (this.show) {
        $(this.modal).modal({backdrop: 'static'});
        $(this.modal).modal('show');
        let event = new Event('showModal', {bubbles: true});
        window.dispatchEvent(event);
      } else {
        $(this.modal).modal('hide');
        $(this.modal).data('bs.modal', null);
      }
    });
  }

  onKeyDown = (e) => {
    //close modal if user hits Escape key
    if (e.keyCode == 27) {
      this.hideModal();
    }
  }

  toggleModal = () => {
    this.show = !this.show;
  }

  showModal = () => {
    this.show = true;
  }

  hideModal = () => {
    this.show = false;
    if (this.props.restoreFocusTo) {
      $(this.props.restoreFocusTo).focus();
    }
  }

  render() {
    return (
      <div className="modal-wrapper" onKeyDown={this.onKeyDown}>
        <Portal>
          <div id={this.props.id}
            ref={i => this.modal = i}
            role="dialog"
            tabIndex={'-1' /* Required to trap focus */}
            className="modal fade"
            aria-labelledby={this.props.id + '-aria-text'}>

            <div className="modal-dialog">
              <div className="modal-content">
                <button type="button" className="fn-modal-close" onClick={this.hideModal}>
                  <i aria-hidden="true" className="icon-close"></i>
                  <span className="sr-only">Close window</span>
                </button>
                <div className="row no-gutters" id={this.props.id + '-aria-text'}>
                  <div className="col-12 text-center">
                    <h1 className="as-h2">{this.props.title}</h1>
                    {this.props.children}
                  </div>
                </div>
                <div className="row no-gutters modal-actions">
                  <div className="col-12 text-center">
                    {/* If there are two buttons, the primary button should be on the right. */}
                    {this.props.secondaryAction !== undefined &&
                      <button className={`fn-secondary ${this.props.secondaryButtonClass}`} onClick={this.props.secondaryAction}>
                        {this.props.secondaryButtonLabel}
                      </button>
                    }
                    <button className={`fn-primary ${this.props.primaryButtonClass}`} onClick={this.props.primaryAction}>
                      {this.props.primaryButtonLabel}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      </div>
    );
  }
}
